<template>
  <v-item-group v-model="model" mandatory :multiple="multiple">
    <slot></slot>
  </v-item-group>
</template>

<script>
export default {
  name: 'OptionList',
  props: {
    value: {
      type: [Object, String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      set: function (value) {
        this.$emit('input', value);
      },
      get: function () {
        return this.value;
      },
    },
  },
};
</script>
